import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { ThemeProvider } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"

import {
  customTheme,
  MetricGoalsHeaderMid,
  MetricHeaderLeft,
  MetricHeaderRight,
} from "./Atom"
import { DropdownFilter } from "../../Dropdown"
import ViewOpportunityButton from "../../Button/ViewOpportunityButton"
import { HeaderInfoNav } from "../Reusable"
import { MetricHeaderWrapper } from "../Atom"

import {
  setMaevaSelectedRegions,
  setMaevaSelectedPractices,
  setOpportunitySelectedGroupByRole,
  setSelectedMetricOpportunityTab,
  setMaevaSelectedGroupsNoAll,
  setMaevaSelectedGroups,
} from "../../../redux/slices/metricSlice"

export default function MetricOpportunityHeader({ name }: { name: string }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  // Extract metric state
  const {
    maevaGroups,
    maevaRegions,
    maevaPractices,
    maevaSelectedGroupsNoAll,
    maevaSelectedRegions,
    maevaSelectedPractices,
  } = useSelector((state: any) => state.metric)

  const selectedGroupFilter = maevaSelectedGroupsNoAll?.[0]
  const selectedRegionFilter = maevaSelectedRegions?.[0]
  const selectedPracticeFilter = maevaSelectedPractices?.[0]

  // Handlers with useCallback for performance optimization
  const handleBackClick = useCallback(() => navigate(-1), [navigate])

  const handleGroupFilter = useCallback(
    (e: any, value: any) => {
      const selectedValue = value?.props?.value
      dispatch(setOpportunitySelectedGroupByRole(selectedValue))
      dispatch(setMaevaSelectedGroupsNoAll([selectedValue]))
      dispatch(setMaevaSelectedGroups([selectedValue]))

      dispatch(
        setMaevaSelectedRegions([{ label: "All", region: "all", name: "all" }]),
      )
      dispatch(
        setMaevaSelectedPractices([
          { label: "All", name: "all", practice_sk: "all" },
        ]),
      )
      dispatch(setSelectedMetricOpportunityTab(0))
    },
    [dispatch],
  )

  const handleRegionFilter = useCallback(
    (e: any, value: any) => {
      dispatch(setMaevaSelectedRegions([value?.props?.value]))
      dispatch(
        setMaevaSelectedPractices([
          { label: "All", name: "all", practice_sk: "all" },
        ]),
      )
    },
    [dispatch],
  )

  const handlePracticeFilter = useCallback(
    (e: any, value: any) => {
      dispatch(setMaevaSelectedPractices([value?.props?.value]))
    },
    [dispatch],
  )

  return (
    <ThemeProvider theme={customTheme}>
      <MetricHeaderWrapper>
        <MetricHeaderLeft>
          <HeaderInfoNav name={name} handleClickBack={handleBackClick} />
        </MetricHeaderLeft>

        <MetricGoalsHeaderMid>
          <DropdownFilter
            id={1}
            disabled={false}
            handleFilter={handleGroupFilter}
            retainedValue={selectedGroupFilter}
            filterData={maevaGroups}
            headerLabel="Group Name"
            selectedGroupFilter={selectedGroupFilter}
          />
          <DropdownFilter
            id={2}
            disabled={!selectedGroupFilter}
            handleFilter={handleRegionFilter}
            retainedValue={selectedRegionFilter}
            filterData={maevaRegions}
            headerLabel="Regions"
          />
          <DropdownFilter
            id={3}
            disabled={!(selectedGroupFilter && selectedRegionFilter)}
            handleFilter={handlePracticeFilter}
            retainedValue={selectedPracticeFilter}
            filterData={maevaPractices}
            headerLabel="Offices"
          />
        </MetricGoalsHeaderMid>

        <MetricHeaderRight>
          <ViewOpportunityButton />
        </MetricHeaderRight>
      </MetricHeaderWrapper>
    </ThemeProvider>
  )
}
